<template>
    <div>
       <!--  <button-back/> -->
       
        <div v-if="locations.length > 0" class="map_filter">
            <div class="maphighlight__box torrea">
                <h1 class="caption__select">
                    <!-- <span>{{img.name}}</span>
                    <span>Seleccione un departamento, clic para ver detalles</span> -->
                </h1>
                <map-highlight :img="img" :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :type="type" :nivel="nivel" />
                <!-- <Button :img="img" :id="id" :desarrollo="desarrollo" :nivel="nivel" :levelId="levelId" :url="url" />
                <div class="line_horizontal"></div> -->
                <div>
                    <image-location class="image__location-small" :typeImage="typeImage" :urlImg="urlImg"/>
                    <detail-location :totalMeters="true" :typeImage="typeImage"/>
                    <btn-detail style="margin-top:2rem" @clickBtn="openM()" />
               </div>
               <DetailModal :modalShow="modal" @modalHide="closeM">
                <template slot="title-detail">{{ modelDpt.name }}</template>
                 <template slot="content-detail">
                    <Detail />
                 </template>
               </DetailModal>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MapHighlight from "../../core/rediseno/ButtonsPisos.vue";
/* import ButtonBack from "../../core/ButtonBack";
import Button from "../../core/Button.vue"; */
import ImageLocation from "../../core/rediseno/ImageIndividual";
import DetailLocation from "../../core/rediseno/DetailLocation";
import BtnDetail from "../../core/rediseno/BtnDetail.vue";
import DetailModal from "../../core/rediseno/modal/DetailModal";
import Detail from "../detailLocation/Main.vue"
export default {
    name: "Piso",
    components: {
        MapHighlight,
        /* Button,
        ButtonBack, */
        ImageLocation,
        DetailLocation,
        BtnDetail,
        DetailModal,
        Detail
    },
    data() {
        return {
            id: 49,
            levelId: this.$route.params.idPiso,
            type: "departamentos",
            desarrollo: "torrespaseodelparquepiso",
            arrFilteredLocations: [],
            nivel: "availability",
            url: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
            //image adition
            typeImage: "modeloDeptos",
            urlImg: 'torrespasodelparque/modelos',
            //
            pisos: {
                PLANTABAJA: {
                    name: 'PLANTA BAJA',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrespasodelparque/pisos/PLANTABAJA.png',
                    width: '938',
                    id: 49,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '964',
                    transform: '',
                    viewBox: '0 0 938 964'
                },
                PISO1: {
                    name: 'PISO 1',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrespasodelparque/pisos/PISO1.png',
                    width: '938',
                    id: 49,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '964',
                    transform: '',
                    viewBox: '0 0 938 964'
                },
                PISO2: {
                    name: 'PISO 2',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrespasodelparque/pisos/RESTO.png',
                    width: '938',
                    id: 49,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                PISO3: {
                    name: 'PISO 3',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrespasodelparque/pisos/RESTO.png',
                    width: '938',
                    id: 49,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                PISO4: {
                    name: 'PISO 4',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrespasodelparque/pisos/RESTO.png',
                    width: '938',
                    id: 49,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                PISO5: {
                    name: 'PISO 5',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrespasodelparque/pisos/RESTO.png',
                    width: '938',
                    id: 49,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                PISO6: {
                    name: 'PISO 6',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrespasodelparque/pisos/RESTO.png',
                    width: '938',
                    id: 49,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                PISO7: {
                    name: 'PISO 7',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrespasodelparque/pisos/RESTO.png',
                    width: '938',
                    id: 49,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                PISO8: {
                    name: 'PISO 8',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrespasodelparque/pisos/RESTO.png',
                    width: '938',
                    id: 49,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                PISO9: {
                    name: 'PISO 9',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrespasodelparque/pisos/RESTO.png',
                    width: '938',
                    id: 49,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                PISO10: {
                    name: 'PISO 10',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrespasodelparque/pisos/RESTO.png',
                    width: '938',
                    id: 49,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                PISO11: {
                    name: 'PISO 11',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrespasodelparque/pisos/RESTO.png',
                    width: '938',
                    id: 49,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                PISO12: {
                    name: 'PISO 12',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrespasodelparque/pisos/RESTO.png',
                    width: '938',
                    id: 49,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
            },
            // si no hay filtro volver rangeFilter a false
            rangeFilter: false,
            activeModel: "",
            //add
            modal:false
        };
    },
    computed: {
        ...mapGetters({
            locations: "getLocations",
            filterModelos: "getStatusFilterModelos",
            levelDept:"getStatusLevel",
            modelDpt:'getStatusA'
        }),
        development() {
            return { id: this.id, level: this.levelDept.id };
        },
        img() {
            const piso = this.$route.params.piso;
            const pisoSeleccionado = this.pisos[piso];
            return pisoSeleccionado;
        },
        amountAvailables() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.status == 2
            );
            return newArrfiltered;
        },
        existFilter() {
            return this.locations
        },
    },
    methods: {
        ...mapActions(["getAvailableLocations", "clearCoords", "getFilterModelos"]),
        changeRange(arrFilter) {
            this.arrFilteredLocations = arrFilter;
        },
        updateActiveModel(model) {
            this.getFilterModelos(model);
        },
        openM(){
            this.modal=true
        },
        closeM(){
            this.modal=false
        },
    },
    async created() {
        /* await this.getAvailableLocations(this.development);
        this.getFilterModelos(this.existFilter) */
    },
    async beforeDestroy() {
        await this.clearCoords();
    },
    mounted() {

    }
};
</script>
<style>
@media (min-width:1201px) {
    .maphighlight__box.torrea{
    width: 60%;   
    }
}
</style>
